var map = {
	"./1": 37309,
	"./1.jpg": 37309,
	"./2": 83154,
	"./2.jpg": 83154,
	"./3": 59535,
	"./3.jpg": 59535,
	"./4": 33156,
	"./4.jpg": 33156,
	"./5": 6753,
	"./5.jpg": 6753,
	"./bg": 667,
	"./bg.png": 667
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70133;